module.exports = __webpack_public_path__ + "img/simLogo.43adf3e3.png";